export default __webpack_public_path__ + "static/media/arrow.54530b5c.svg";